import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption , MDBIcon, MDBFormInline} from "mdbreact";
import {  MDBRow, MDBCol } from "mdbreact";

import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { api } from '../../api';
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2'

export default class Modaladdworkpay extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   send_comment1:"",
   send_comment4:"",

   filecomment1:null,
   filecomment2:null,

   name_workorder:'',//ชื่องาน
   namecustomer_workorder:'',//ชื่อลูกค้า
   tel_workorder:'',//เบอร์ลูกค้า
   idline_workorder:'',//ไลน์ลูกค้า
   facebook_workorder:'',//เฟชบุคลูกค้า
   appointment_workorder:'',//นัดรับงาน
   example_workorder:'',//ตัวอย่าง
   description_workorder:'',//รายละเอียด
   price_workorder:'0',//จำนวนเงิน
   deposit_workorder:'0',//เงินมัดจำ
   remain_workorder:'0',//คงเหลือ
   paymentstatus_workorder:'',//สถานะการจ่าย
   code_workorder:'',//รหัส
   showcode1:'',//รหัส
   status_workorder:'1',
   coderun:'',

   radio: '-',
   materialvinyl: '-',
   papertype:'-',
   statecut:'-',


   workeditdata:[],
   id_workorder:'',
   material_workorder:'',
   materialvinyl_workorder:'',





}

//this.handleChange = this.handleChange.bind(this);
//this.handleChange2 = this.handleChange2.bind(this);
//this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
//this.handleChange4 = this.handleChange4.bind(this);
this.handleChangefile = this.handleChangefile.bind(this);
this.onTextChange = this.onTextChange.bind(this);
this.onChangetype = this.onChangetype.bind(this);
this.onClick = this.onClick.bind(this);
this.onClickmaterialvinyl = this.onClickmaterialvinyl.bind(this);
this.onClickpapertype = this.onClickpapertype.bind(this);
this.onClickstatecut = this.onClickstatecut.bind(this);
this.getwork = this.getwork.bind(this);



}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.getwork ()
}

handleChangefile(event) {    this.setState({example_workorder: event.target.files[0]});  }

onTextChange = (e) => {
  this.setState({ [e.target.name]: e.target.value })
}

onChangetype(value) {
  this.setState({ paymentstatus_workorder:value})
}

onClick = (nr) => () => {
  this.setState({
    radio: nr,
  });
};

onClickmaterialvinyl = (nr) => () => {
  this.setState({
    materialvinyl: nr,
  });
};

onClickpapertype = (nr) => () => {
  this.setState({
    papertype: nr,
  });
};

onClickstatecut = (nr) => () => {
  this.setState({
    statecut: nr,
  });
};


getwork (){
   // const {id_workorder} = this.state.id_workorder
    api.get('selectworkedit.php?id_workorder='+this.props.id_workorder)
    .then(res => {
    //  console.log(res);
      this.setState({ workeditdata: res.data, loading: false })
      this.setState({ id_workorder: res.data[0].id_workorder})
      this.setState({ code_workorder: res.data[0].code_workorder})
      this.setState({ name_workorder: res.data[0].name_workorder})
      this.setState({ namecustomer_workorder: res.data[0].namecustomer_workorder})
      this.setState({ tel_workorder: res.data[0].tel_workorder})
      this.setState({ idline_workorder: res.data[0].idline_workorder})
      this.setState({ facebook_workorder: res.data[0].facebook_workorder})
      this.setState({ appointment_workorder: res.data[0].appointment_workorder})
      this.setState({ example_workorder: res.data[0].example_workorder})
      this.setState({ description_workorder: res.data[0].description_workorder})
      this.setState({ radio: res.data[0].material_workorder})
      this.setState({ materialvinyl: res.data[0].materialvinyl_workorder})
      this.setState({ papertype: res.data[0].papertype_workorder})
      this.setState({ statecut: res.data[0].statecut_workorder})
      this.setState({ price_workorder: res.data[0].price_workorder})
      this.setState({ deposit_workorder: res.data[0].deposit_workorder})
      this.setState({ remain_workorder: res.data[0].remain_workorder})
      this.setState({ paymentstatus_workorder: res.data[0].paymentstatus_workorder})
     // this.setState({ FACULTY: res.data[0].FACULTY})
     //  this.setState({ PNAME: res.data[0].PNAME})
     // this.setState({ FACULTY: res.data[0].FACULTY})
    }) 
}


 componentDidMount() {
    //  const { id_send } = this.props.id_send
   //   console.log(id_send);
     // this.setState({ id_send:this.props.id_send})
     //this.getwork ()
  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


 // handleChange(event) {    this.setState({filecomment1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({filecomment2: event.target.files[0]});  }
 // handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
 // handleChange4(event) {    this.setState({send_comment4: event.target.value});  }


  handleSubmit(e) {
    e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {
    const date = new Date().toISOString().slice(0, 10)
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล

      datafrm.append("datesent", date);
      datafrm.append("deposit_workorder", this.state.deposit_workorder);
      datafrm.append("remain_workorder", this.state.remain_workorder);
     // datafrm.append("paymentstatus_workorder", this.state.paymentstatus_workorder);
      datafrm.append("id_workorder", this.state.id_workorder);
      //datafrm.append("status_workorder", this.state.status_workorder);
     // datafrm.append("coderun", this.state.coderun);
      

     
      
      api.post("updatepay.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
  
   // console.warn(res);
   // console.log("response: ", res)

    if (res.status=== 200) {
        Swal.fire({
            title: 'ชำระเงินสำเร็จ',
            icon: 'success',
          // showCancelButton: true,
            confirmButtonText: 'ตกลง',
          // cancelButtonText: 'No, keep it'
          }).then((result) => {
            this.toggle(); 
            this.props.getwork()
          })
    }else{
      message.error("ชำระเงินไม่สำเร็จ!")
    }
  })


//อัพเดทสถานะ
  // Axios
  // // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
  //   .post("https://conference.kpru.ac.th/PHPAPI/updatestapat4.php",datafrm)
  //   .then(res => {
  //     console.log("response: ", res)
 
  //     if (res.data.length !== 0) {
  //      // this.showitem = true;
  //       console.log(res)
  //       console.log(res.data.length)
  //    }else{
  //     // window.location.href = '/'
  //    }
  //    this.toggle()
  //  })
  // this.toggle()


}, 1000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 


  }

  

    render() {
console.log(this.state.name_workorder)
console.log(this.state.namecustomer_workorder)
console.log(this.state.tel_workorder)
console.log(this.state.idline_workorder)
console.log(this.state.facebook_workorder)
console.log(this.state.appointment_workorder)
console.log(this.state.example_workorder)
console.log(this.state.description_workorder)
console.log(this.state.price_workorder)
console.log(this.state.deposit_workorder)
console.log(this.state.remain_workorder)
console.log(this.state.paymentstatus_workorder)
console.log(this.state.code_workorder) 

console.log(this.state.radio) 
console.log(this.state.materialvinyl) 
console.log(this.state.papertype) 
console.log(this.state.statecut) 

//console.log("1".padStart(5, "0"));

        return (
            <>
            <MDBBtn color="info" size="sm" onClick={this.toggle}><MDBIcon icon="dollar-sign" /> ชำระเงิน</MDBBtn>

            
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
              <MDBModalHeader toggle={this.toggle} className="text-center"><MDBIcon icon="dollar-sign" /> ชำระเงิน</MDBModalHeader><br/>
              {/* <div className="text-center"><h4>ร้านลูกแม่น้ำปิงไวนิล 055-023245, 092-5583982, 0827730380</h4></div> */}
              
              
              <MDBModalBody className="text-left">
              <div>
                <h5 className="text-left font-weight-bold"> รหัส : {this.state.code_workorder}</h5>   <br/>
              <form onSubmit={this.handleSubmit}>
                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> ชื่องาน</label>
                                <input className="form-control" onChange={this.onTextChange} name="name_workorder"
                                    value={this.state.name_workorder} placeholder="" required  disabled />
                            </div>
                            <hr/>
                            <MDBRow>
                              <MDBCol md="4">
                                 <div className="mb-2">
                                   <label className="font-weight-bold"><MDBIcon icon="user-times" /> ชื่อลูกค้า</label>
                                   <input className="form-control" onChange={this.onTextChange} name="namecustomer_workorder"
                                    value={this.state.namecustomer_workorder} placeholder="" required  disabled />
                                 </div>
                                </MDBCol>
                              <MDBCol md="4">
                                  <div className="mb-2">
                                      <label className="font-weight-bold"><MDBIcon icon="phone-volume" /> เบอร์โทรลูกค้า</label>
                                      <input className="form-control" onChange={this.onTextChange} name="tel_workorder"
                                          value={this.state.tel_workorder} placeholder="" required disabled  />
                                  </div>
                              </MDBCol>
                              <MDBCol md="4">
                                 <div className="mb-2">
                                 <label className="font-weight-bold"><MDBIcon fab icon="line" /> ID LINE</label>
                                 <input className="form-control" onChange={this.onTextChange} name="idline_workorder"
                                    value={this.state.idline_workorder} placeholder="" required disabled />
                                  </div>
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol md="4">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon fab icon="facebook" /> FACEBOOK</label>
                                        <input className="form-control" onChange={this.onTextChange} name="facebook_workorder"
                                            value={this.state.facebook_workorder} placeholder="" required disabled  />
                                </div>
                              </MDBCol>
                              <MDBCol md="4">
                                <div className="mb-2">
                                    <label className="font-weight-bold"><MDBIcon icon="calendar-alt" /> นัดรับงานวันที่</label>
                                    <input className="form-control" type="date" onChange={this.onTextChange} name="appointment_workorder"
                                        value={this.state.appointment_workorder} placeholder="" required disabled  />
                                </div>
                              </MDBCol>
                            
                            </MDBRow>

                            <hr/>

                          

                            <MDBRow>
                              <MDBCol md="6">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="donate" /> จำนวนเงิน</label>
                                        <input className="form-control" onChange={this.onTextChange} name="price_workorder"
                                            value={this.state.price_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              <MDBCol md="6">
                                <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="hand-holding-usd" /> จำนวนเงินมัดจำ</label>
                                        <input className="form-control" onChange={this.onTextChange} name="deposit_workorder"
                                            value={this.state.deposit_workorder} placeholder="" required />
                                </div>
                              </MDBCol>
                              {/* <MDBCol md="4">
                              <div className="mb-2">
                                        <label className="font-weight-bold"><MDBIcon icon="comments-dollar" /> คงเหลือ</label>
                                        <input className="form-control" onChange={this.onTextChange} name="remain_workorder"
                                            value={this.state.remain_workorder} placeholder="" required />
                                </div>
                              </MDBCol> */}
                            </MDBRow>
                          

                            <div className="mb-2">
                                <label className="font-weight-bold"><MDBIcon icon="money-check-alt" /> ประเภทการชำระ</label><br/>
                                <Select
                                    value={this.state.paymentstatus_workorder}
                                    showSearch
                                    style={{ width:"100%" }}
                                    placeholder="เลือกประเภทการชำระ"
                                    optionFilterProp="children"
                                    onChange={this.onChangetype}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    onSearch={this.onSearch}
                                    filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    disabled 
                                >
                                <option value="1">แบบเงินสด</option>
                                <option value="2">แบบเบิกจ่าย</option>
                              
                                 </Select>
                            </div><br/>

                            <h1 className="text-center font-weight-bold"> คงเหลือ : <NumberFormat value= {this.state.remain_workorder}  displayType={'text'} thousandSeparator={true}  /></h1>

                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="primary" className="text-center"> <MDBIcon far icon="save" /> ชำระเงิน</MDBBtn>
                            </div>


                        </form>


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
